import { useTranslation } from 'react-i18next';
import { PencilSquareIcon } from '@heroicons/react/24/outline';

import ComingSoonTooltip from '@/components/ui/custom/dataDisplay/ComingSoonTooltip';
import { Button } from '@/components/ui/daisy';

export default function ExamCorrectActionCell() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pendencies.exams',
  });

  return (
    <ComingSoonTooltip disabled>
      <Button size="sm" color="warning" variant="soft" disabled>
        <PencilSquareIcon className="w-4" />
        {t('correct')}
      </Button>
    </ComingSoonTooltip>
  );
}
